
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHeavySnowShowersPolartwilightColour as ObiHeavySnowShowersPolartwilightColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-heavy-snow-showers-polartwilight-colour.js';
 
 
 

 
 export const ObiHeavySnowShowersPolartwilightColour = createComponent({
   react: React,
   tagName: 'obi-heavy-snow-showers-polartwilight-colour',
   elementClass: ObiHeavySnowShowersPolartwilightColourElement,
   events: {
     
   }
  });
 
 